import { useEffect } from "react";
import {  Socket } from 'socket.io-client';

export const useSocketListener = (
  eventName: string,
  socket: Socket,
  handler: (...input: any) => void
) => {
  useEffect(() => {
    socket.on(eventName, handler);
    return () => {
      socket.off(eventName, handler);
    };
  }, [eventName, handler, socket]);
};

// [] = "en gång"
// null = "varje gång"
